'use client';
import { createContext, useContext } from 'react';
const ShadowPortalContext = createContext(null);
export const ShadowPortalProvider = ShadowPortalContext.Provider;
export function useShadowPortal() {
    const container = useContext(ShadowPortalContext);
    return container !== null && container !== void 0 ? container : undefined;
}
